import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { LazySelect } from './lazy-select';


export class LazySelectModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: LazySelectModule, providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  exports: [
    LazySelect
  ],
  declarations: [
    LazySelect
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
